module.exports = __webpack_public_path__ + "static/media/in-progress.59fd3776.svg";